<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Smoke and Mirrors</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head"><em>Recent Titles by Casey Daniels</em></h3>
<p class="books-by-text-space-after"><em>The Pepper Martin Mysteries</em></p>
<p class="books-by-text">DON OF THE DEAD</p>
<p class="books-by-text">THE CHICK AND THE DEAD</p>
<p class="books-by-text">TOMBS OF ENDEARMENT</p>
<p class="books-by-text">NIGHT OF THE LOVING DEAD</p>
<p class="books-by-text">DEAD MAN TALKING</p>
<p class="books-by-text">TOMB WITH A VIEW</p>
<p class="books-by-text">A HARD DAY’S FRIGHT</p>
<p class="books-by-text">WILD WILD DEATH</p>
<p class="books-by-text">SUPERNATURAL BORN KILLERS</p>
<p class="books-by-text-space-after">GRAVEYARD SHIFT*</p>
<p> </p>
<p class="books-by-text-space-after"><em>The Miss Barnum Mysteries</em></p>
<p class="books-by-text-space-after">SMOKE AND MIRRORS*</p>
<p> </p>
<p class="books-by-text"><span class="small"><em>* available from Severn House</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?2dfce390